import { fillQueryPair } from './fillQueryPair';

interface Args {
  query: string;
  values: Record<string, string>;
}

export const fillQueryString = ({ query, values }: Args): string =>
  query
    .split('&')
    .filter(Boolean)
    .map((pair) => fillQueryPair({ pair, values }))
    .filter((pair): pair is string => !!pair)
    .join('&');
